// @flow
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import AppIcons from '../Common/AppIcons';
import LegacyLink from '../Common/LegacyLink';
import JustParkLogo from '../UI/JustParkLogo';
import Zendesk from '../Common/ZendeskLink';

import '../../../static/scss/components/footer.scss';

const Footer = () => (
  <div className="c-footer">
    <div className="c-footer__container">
      <div className="c-footer__logo">
        <a>
          <JustParkLogo />
        </a>
      </div>
      <div className="c-footer__menu c-footer__menu--primary">
        <ul className="c-footer__menu--primary__list">
          <li>
            <ul>
              <li>
                <LegacyLink className="mobile-hidden" to="about/">
                  About
                </LegacyLink>
              </li>
              <li>
                <LegacyLink to="about/how-it-works/">How it works</LegacyLink>
              </li>
              <li>
                <Zendesk isFooter>Help</Zendesk>
              </li>
              <li>
                <LegacyLink to="refer-a-friend/">Get free parking</LegacyLink>
              </li>
              <li>
                <LegacyLink to="about/student-discount/">
                  Student discount
                </LegacyLink>
              </li>
              <li>
                <LegacyLink to="about/jobs/">Jobs</LegacyLink>
              </li>
              <li>
                <LegacyLink to="blog/">Blog</LegacyLink>
              </li>
              <li>
                <LegacyLink
                  className="mobile-hidden"
                  to="about/media-coverage/"
                >
                  Media
                </LegacyLink>
              </li>
              <li>
                <LegacyLink
                  className="desktop-hidden"
                  to="cancellation-policy/"
                >
                  Cancellation policy
                </LegacyLink>
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li>
                <a href="https://help.justpark.com/hc/en-us">Contact us</a>
              </li>
              <li>
                <LegacyLink className="desktop-hidden" to="uk/airport-parking">
                  Airport parking
                </LegacyLink>
              </li>
              <li>
                <LegacyLink className="desktop-hidden" to="uk/stadium-parking">
                  Stadium parking
                </LegacyLink>
              </li>
              <li>
                <LegacyLink
                  className="desktop-hidden"
                  to="uk/national-rail-parking"
                >
                  Station parking
                </LegacyLink>
              </li>
              <li>
                <LegacyLink className="desktop-hidden" to="uk/">
                  City parking
                </LegacyLink>
              </li>
              <li>
                <LegacyLink
                  className="desktop-hidden"
                  to="about/business-parking/"
                >
                  Corporate accounts
                </LegacyLink>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div className="c-footer__menu">
        <ul>
          <li>
            <LegacyLink to="car-park-management/cashless-parking-payments/">
              Cashless parking solution
            </LegacyLink>
          </li>
          <li>
            <LegacyLink to="car-park-management/">
              Car park management
            </LegacyLink>
          </li>
          <li>
            <LegacyLink to="car-park-management/hotels/">
              Hotel car parks
            </LegacyLink>
          </li>
          <li>
            <LegacyLink to="rent-out-a-parking-space/">
              Rent out your driveway
            </LegacyLink>
          </li>
          <li>
            <LegacyLink to="uk/airport-parking/">Airport parking</LegacyLink>
          </li>
          <li>
            <LegacyLink to="uk/stadium-parking/">Stadium parking</LegacyLink>
          </li>
          <li>
            <LegacyLink to="uk/national-rail-parking/">
              Station parking
            </LegacyLink>
          </li>
          <li>
            <LegacyLink to="uk/">City parking</LegacyLink>
          </li>
          <li>
            <LegacyLink to="about/business-parking/">
              Corporate accounts
            </LegacyLink>
          </li>
        </ul>
      </div>
      <div className="c-footer__menu c-footer__menu--primary">
        <ul className="c-footer__social">
          <li>
            <a
              href="https://www.facebook.com/JustParkHQ/"
              target="_blank"
              rel="noopener noreferrer"
              className="icon-facebook"
            />
          </li>
          <li>
            <a
              href="https://twitter.com/JustPark"
              target="_blank"
              rel="noopener noreferrer"
              className="icon-twitter"
            />
          </li>
        </ul>
        <AppIcons baseClassName="c-footer__shop" />
        <div className="c-footer__copylink--mobile">
          <a href="/">&copy; Copyright JustPark 2019</a>
        </div>
      </div>
    </div>
    <hr />
    <div className="c-footer__container c-footer__container--secondary">
      <div>
        <ul>
          <li>
            <a href="/">&copy; Copyright JustPark 2019</a>
          </li>
          <li>
            <LegacyLink to="sitemap/">Site map</LegacyLink>
          </li>
          <li>
            <LegacyLink to="cancellation-policy/">
              Cancellation policy
            </LegacyLink>
          </li>
          <li>
            <LegacyLink to="terms-and-conditions/">Terms of use</LegacyLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default Footer;
